module.exports = __webpack_public_path__ + "2acb60f2/img/comments-icon.fdec7fdb.svg";